declare global {
  interface Window {
    YT: any;
    onYouTubeIframeAPIReady?: Function;
  }
}

export default class YouTubeIframeLoader {
  src: string;
  loading: boolean;
  loaded: boolean;
  listeners: Function[];

  constructor() {
    this.src = 'https://www.youtube.com/iframe_api';
    this.loading = false;
    this.loaded = false;
    this.listeners = [];

    if(typeof window?.YT?.Player !== 'undefined') {
      this.loaded = true;
    }
  }

  load(callback) {
    this.listeners.push(callback);

    if (this.loaded) {
      setTimeout(() => {
        this.done();
      });
      return;
    }

    if (this.loading) {
      return;
    }

    this.loading = true;

    window.onYouTubeIframeAPIReady = () => {
      this.loaded = true;
      this.done();
    };

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = this.src;
    document.body.appendChild(script);
  }

  done() {
    delete window.onYouTubeIframeAPIReady;

    while (this.listeners.length) {
      const listener = this.listeners.pop();
      if (listener) {
        listener(window.YT);
      }
    }
  }
}

export const instance = new YouTubeIframeLoader();

